
import { RevButton } from '@ds/components/Button'

import { getContentFromContentService } from '@http/endpoints'

import translations from './NoResultsButton.translations'

export default {
  components: {
    RevButton,
  },
  props: {
    fullWidth: {
      type: String,
      default: undefined,
    },
    tracking: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      buttonLabel: '',
      buttonLink: undefined,
      isLoading: true,
    }
  },
  computed: {
    translations: () => translations,

    shouldDisplayButton() {
      return (
        this.isLoading ||
        (!this.isLoading && this.buttonLink && this.buttonLabel)
      )
    },
  },
  mounted() {
    this.fetchLandingNoResults()
  },
  methods: {
    async fetchLandingNoResults() {
      try {
        const { payload } = await this.$store.dispatch('http/request', {
          request: getContentFromContentService,
          pathParams: {
            pageType: 'landing-page-no-results',
            pageName: 'default',
          },
        })
        this.buttonLink = payload.blocks?.[0]?.props?.primary?.link
        this.buttonLabel = payload.blocks?.[0]?.props?.primary?.label
      } finally {
        this.isLoading = false
      }
    },
  },
}
